<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="calibre3"><span id="Page_2" title="[Pg 2]"></span></p>
<h2 class="nobreak" id="Second_Day">Second Day.</h2>
</div>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="calibre10">
<img alt="" class="drop-cap" id="id-4105359371250540193" src="Images/img0003.jpg"/>
</div>
<div class="pcalibre verse">Show me the man who says</div>
<div class="verse1">anything against women,</div>
<div class="verse5">as women, and I boldly declare,</div>
<div class="verse2">he is not a man.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Pickwick.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">Natural affection and instinct are the</div>
<div class="verse6">most beautiful</div>
<div class="verse1">of the Almighty’s works.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Charles Cheeryble.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse5">It must be somewhere written that the</div>
<div class="verse4">virtues of the mothers</div>
<div class="verse">shall occasionally be visited on the children,</div>
<div class="verse2">as well as the sins of their fathers.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Mr. Jarndyce.</i></p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">We can all do some good, if we will.</div>
</div>
</div>
</div>
<p class="author"><i class="calibre8">Dickens.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?3e25a64f